import { AppUser, IAppUser } from "./app-user.model";
import { Gate, IGate } from "./gate.model";

export interface IGuard {
  uidGuard: string;
  neighborhoodId: string;
  gateId?: string;
  digitalLogModule: boolean;
  bookingsModule: boolean;
  aiModuleVisits: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  gate?: IGate;
  guard?: IAppUser;
}

export class Guard {
  uidGuard: string;
  neighborhoodId: string;
  gateId?: string;
  digitalLogModule: boolean;
  bookingsModule: boolean;
  aiModuleVisits: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
  gate?: Gate;
  guard?: AppUser;

  constructor(data: IGuard) {
    this.uidGuard = data.uidGuard;
    this.neighborhoodId = data.neighborhoodId;
    this.gateId = data.gateId;
    this.digitalLogModule = data.digitalLogModule;
    this.bookingsModule = data.bookingsModule;
    this.aiModuleVisits = data.aiModuleVisits;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.gate = data.gate 
      ? new Gate(data.gate) 
      : undefined;
    this.guard = data.guard 
      ? new AppUser(data.guard)
      : undefined;
  }

  get fullName(): string {
    return this.guard ? this.guard.fullName : '';
  }

}
